import Service from "../AuthService";

const Status = {
    checkPermission(type, mod) {
        return Service.get(`check-permission/${type}/${mod}`);
    },
    getPermissionList() {
        return Service.get('settings/permissions')
    },
    getUserGroupList() {
        return Service.get('user-group')
    },
    setUserGroupList(id, payload) {
        return Service.put(`settings/permissions/${id}`, payload)
    }
};

export default Status;
